<template>
  <div class="portal-reviews-filter__list-container" ref="container">
    <a
      class="portal-reviews-filter__popup-link"
      :href="summaryFilteredUrl"
      v-if="tipPositionStyle"
      :style="tipPositionStyle"
    >
      Показать
    </a>

    <ul class="portal-reviews-filter__list">
      <li
        class="portal-reviews-filter__item"
        v-for="trait in traits"
        :key="trait.id"
      >
        <button
          :class="[
            'portal-reviews-filter__checkbox',
            trait.checked ? 'portal-reviews-filter__checkbox_checked' : '',
          ]"
          v-on:click="$emit('click', trait.id)"
        ></button>

        <span class="portal-reviews-filter__link-container">
          <a
            class="portal-reviews-filter__link"
            :href="trait.link"
            :ref="trait.id"
          >
            {{ trait.value }}
          </a>
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import {getTipPositionStyle} from './utils';

export default {
  name: 'traits-list',

  props: {
    // Objects {checked: Bool, id: Number, link: String, value: String, showTip: Bool}
    traits: Array,
    summaryFilteredUrl: String,
  },

  computed: {
    tipPositionStyle: function () {
      return getTipPositionStyle(this.$refs, this.traits);
    },
  },

  // Emits:
  // click: Number
};
</script>

<style lang="scss">
.portal-reviews-filter__list-container {
  position: absolute;
  border: 1px solid var(--black-l65);
  background: var(--black-l95);
  left: 0;
  top: 32px;
  width: 100%;
  padding: 8px 10px;
  font-size: 14px;
  line-height: 16px;
  list-style: none;
  box-sizing: border-box;
  z-index: 3;
}

.portal-reviews-filter__list {
  max-height: 644px;
  overflow-y: auto;
  overflow-x: hidden;
}

.portal-reviews-filter__item {
  display: flex;

  &:not(:last-child) {
    margin-bottom: 16px;
  }
}

.portal-reviews-filter__checkbox {
  width: 16px;
  height: 16px;
  margin-right: 10px;
  box-sizing: border-box;
  border: 1px solid var(--black-l85);
  background: var(--white);
  border-radius: 3px;
  outline: none;
}

.portal-reviews-filter__checkbox_checked {
  position: relative;
  border-color: var(--black-l50);

  &::before {
    content: '';
    position: absolute;
    width: 9px;
    height: 8px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: var(--amber);
    mask-image: url(~src/assets/images/svg/check_mark.svg);
    mask-repeat: no-repeat;
    mask-size: contain;
  }
}

.portal-reviews-filter__link-container {
  position: relative;
}

.portal-reviews-filter__link {
  color: var(--black);

  &:hover {
    text-decoration: none;
  }
}

.portal-reviews-filter__popup-link {
  position: absolute;
  background: var(--white);
  border: 1px solid var(--black-l75);
  font-size: 12px;
  left: calc(100% - -15px);
  line-height: 20px;
  padding: 0 9px;
  top: 50%;
  transform: translate(10px, -4px);
  z-index: 3;

  &::before,
  &::after {
    content: '';
    top: 3px;
    position: absolute;
    margin-left: -7px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 7px 7px 7px 0;
  }

  &::before {
    border-color: transparent var(--black-l65) transparent transparent;
    left: 0;
  }

  &::after {
    border-color: transparent #fff transparent transparent;
    left: 1px;
  }

  &:hover {
    text-decoration: none;
  }
}
</style>
